import React, { useState } from 'react';
import { AccordionDetails, Accordion, AccordionSummary, Typography } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
function Accordioninfo({ items }) {

   const [activeIndex, setActiveIndex] = useState(-1);
   const handleClick = (index) => {
      setActiveIndex(index === activeIndex ? -1 : index);
   };

   return (
      <div className='info-accordion-section'>
         {items?.map((row, index) => {
            return (
               <Accordion>
                  <AccordionSummary aria-controls="panel1a-content" onClick={() => handleClick(index)}>
                     <Typography>
                        <div className="refunds-provide">{row?.title} </div>
                        <p>{index === activeIndex ? "(see less)" : "(see more)"} </p>
                        <span className='accordian-icon'>{index === activeIndex ? <RemoveIcon /> : <AddIcon />} </span>

                     </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                     <Typography>
                        <p>{row?.content}</p>
                     </Typography>
                  </AccordionDetails>
               </Accordion>
            )
         })}

      </div>
   );
}
export default Accordioninfo;